import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

import Choice, { Option } from '@components/choice/Choice'

import { FormikHelpers, useFormik } from 'formik'

import useI18n from '@i18n/useI18n'

interface Values {
  nature: 'PRESTATION' | 'MAINTENANCE'
}

const Nature = ({ form, onForm }: ControleFormProps) => {
  const i18n = useI18n()

  const init: Values = React.useMemo(() => ({ nature: form.nature }), [form.nature])

  const onSubmit = (vals: Values, { setSubmitting }: FormikHelpers<Values>) => {
    const next: Partial<ControleForm> = {
      ...vals,
      manifestationId: undefined, // reset manifestation selection
      period: undefined,
      localisationIds: [],
      reponses: [],
      metierId: undefined,
    }

    onForm(next).finally(() => setSubmitting(false))
  }

  const { values, setFieldValue, handleSubmit, dirty } = useFormik<Values>({
    enableReinitialize: true,
    initialValues: init,
    onSubmit,
  })

  React.useEffect(() => {
    if (dirty) {
      // sumbit on change
      handleSubmit()
    }
  }, [values])

  const options: Option[] = ['PRESTATION', 'MAINTENANCE'].map((s) => ({
    label: i18n.t(`screens.controles.form.nature.${s}`),
    value: s,
  }))
  const option = options.find((o) => o.value === values.nature)

  return (
    <MainContainer>
      <Choice
        data={options}
        onItemSelected={(opt) => setFieldValue('nature', opt.value)}
        value={option}
        inline={false}
      />
    </MainContainer>
  )
}

export default Nature

const MainContainer = styled(View)`
  margin: 0 20px;
  margin-top: ${(props) => (props.theme.breakpoint === 'phone' ? 0 : 75)}px;
  flex: 1;
`
